import { createAsyncThunk } from '@reduxjs/toolkit';
import { createRequest } from '../../../helpers/api/createRequest';
import * as userApi from '../../../api/users';
import { CreateUsersData } from '../../../types/Endpoints/CreateUser';
import { addNotification } from '../../notifications';
import { TypesSnackbars } from '../../../types/TypesSnackbars';
import { Thunk } from '../../../helpers/redux/Thunk';

export const CREATE_USER = 'user/createUser';

const useOnSuccess = (result: any): Thunk => async dispatch => {
    if (result.status) {
        window.location.href = `/client-card/${result.id}`;
    }
    if (!result.status) {
        await dispatch(addNotification({
            type: TypesSnackbars.SUCCESS,
            message: {
                isMistake: true,
                description: 'Пользователь с таким номером телефона уже заведен в системе',
            },
        }));
    }
};

const onFail = (): Thunk => async dispatch => {
    await dispatch(addNotification({
        type: TypesSnackbars.SUCCESS,
        message: {
            isMistake: true,
            description: 'Проверьте введенные данные',
        },
    }));
};

export const createUser = createAsyncThunk(
    CREATE_USER,
    createRequest({
        type: CREATE_USER,
        loader: (userData: CreateUsersData) => userApi.createUser(userData),
        onSuccess: useOnSuccess,
        onFail,
        showFailNotification: false,
    }),
);
